import { RootState } from "@/lib/state/store";

export const timelineSelector = function (state: RootState) {
  return {
    currentFrameIndex: state.editor.currentFrameIndex,
    currentLayerIndex: state.editor.currentLayerIndex,
    sequence: state.animation.sequence,
    frameDimensions: {
      width: state.animation.width,
      height: state.animation.height,
    },
    mode: state.editor.mode,
    framePickerVisible: state.editor.framePickerVisible,
    framePickerMode: state.editor.framePickerMode,
  };
};
